import store from './index';
export const selectCatalog = () => store((state) => state);
export default {
    removeDistrict: store.getState().removeDistrict,
    addProject: store.getState().addProject,
    removeProject: store.getState().removeProject,
    addUnit: store.getState().addUnit,
    removeUnit: store.getState().removeUnit,
    sort: store.getState().sort,
    clearCatalog: store.getState().clearCatalog,
    setSettings: store.getState().setSettings,
    resetSettings: store.getState().resetSettings,
    dropCatalog: store.getState().dropCatalog,
    getCatalog: store.getState().getCatalog,
    getLastCatalog: store.getState().getLastCatalog,
    createCatalog: store.getState().createCatalog,
    editCatalog: store.getState().editCatalog,
    publishCatalog: store.getState().publishCatalog,
    generateCatalog: store.getState().generateCatalog,
    openAdminPreviewCatalog: store.getState().openAdminPreviewCatalog,
};
